import { NgModule } from '@angular/core';

import { SharedGlobalModule } from '../shared-global/shared-global.module';

import { AuthHeaderComponent } from './components/auth-header/auth-header.component';
import { LoginComponent } from './pages/login/login.component';
import { AuthComponent } from './auth.component';
import { AuthRoutingModule } from './auth-routing.module';

@NgModule({
  declarations: [LoginComponent, AuthHeaderComponent, AuthComponent],
  imports: [AuthRoutingModule, SharedGlobalModule],
})
export class AuthModule {}
